export const campaignsListMapper = campaignDataArr => {
  const mappedCampaignDataArr = [];

  campaignDataArr.forEach(campaignData => {
    const { campaignTypeDto: campaignType, pricingModel } = campaignData;

    const selectedCampaignType = {
      key: campaignType.campaignTypeId,
      name: campaignType.campaignTypeName,
    };
    const selectedCampaignBilling = {
      key: pricingModel.pricingModelId,
      name: pricingModel.pricingModelName,
    };

    mappedCampaignDataArr.push({
      ...campaignData,
      selectedCampaignType,
      selectedCampaignBilling,
    });
  });

  return mappedCampaignDataArr;
};
